/**
 * Created by Christof Sander on 07.12.2016.
 */

module.exports = {
	extends: [
		'/',
		'base',
		'trees',
		'tree'
	],

	config: {
		treeConfig: {
			plugins: [
				'types',
				'dnd',
				'search'
			],
			core: {
				check_callback: function(operation, node, node_parent, node_position, more) {
					var result = false;
					if(operation === 'move_node'){
						var treesComponent;
						if(more.origin.element && (treesComponent = getComponent($(more.origin.element).closest('.base_trees_trees')))){
							var nodeData = treesComponent.getNodeData(node.id);
							var parentNodeData;
							if(node_parent.id != '#') parentNodeData = treesComponent.getNodeData(node_parent.id);

							result = (
								// allow layouts within layout-sections
								(
									nodeData.subType === 'layout'
									&& (
										!parentNodeData
										||
										(
											parentNodeData.type === 'section'
											&&
											parentNodeData.parentType === 'layout'
										)
									)
								)
								||
								// allow layout sections within another layout
								(
									nodeData.type === 'section'
									&&
									nodeData.parentType === 'layout'
									&&
									parentNodeData
									&&
									parentNodeData.subType === 'layout'
								)
								||
								// allow section-components if ...
								(
									nodeData.type === 'component'
									&&
									nodeData.subType !== 'layout'
									&&
									(
										// ... move-node is a free usage component
										(
											nodeData.config
											&&
											nodeData.config.freeUsageAllowed
										)
										||
										// ... new parent allows free child usage
										(
											parentNodeData
											&&
											parentNodeData.config
											&&
											parentNodeData.config.freeChildUsageAllowed
										)
										||
										// ... new parent is a section
										(
											parentNodeData
											&&
											parentNodeData.type === 'section'
										)
									)
								)
							);
						}
					}
					return result;
				}
			}
		}
	},

	methods: {
		prepare: function(){
			if(this.actualParentComponent && this.actualParentComponent.hasClass('templates_bulk_chooseLayoutTrees')){
				this.config.treeConfig.plugins.splice(this.config.treeConfig.plugins.indexOf('dnd'), 1);
			}
		}
	}
};
